import { createTypographyComponent } from "./helpers";

const P = createTypographyComponent("p", "leading-7 not-first:mt-6");

export default P;
